import { useAdminAuthStore } from '@/stores/admin/auth.js'

export default function adminNotRequireAuth(to, from, next) {
  const authStore = useAdminAuthStore()
  if (authStore.getToken) {
    const redirect = to.query.redirect
    next(typeof redirect === 'string' && redirect.startsWith('/admin') ? redirect : '/admin')
    return
  } else {
    next()
    return
  }
}
